module.exports = "../../app/cells/components/campaigns/widgets/brand/show.erb";